<template>
    <div v-on:click.stop class="brandable-modal-page">
        <div class="images-container">
            <div class="floating-editor">
                <div @click="() => {collapsed = !collapsed}" class="arrow-container">
                    <div class="arrow" :class="collapsed ? 'right' : 'left'"></div>
                </div>
                <div v-if="!collapsed"class="floating-edit-options">
                    <div class="floating-container">
                        <div @click="() => {collapsedNotes = !collapsedNotes}" class="fixed-container clickable"  >
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/editicon_blue.svg?v=1711657195"/> <p>Add Design Note</p> <div class="arrow" :class="collapsedNotes ? 'down' : 'up'"></div>
                        </div>
                        <div v-show="!collapsedNotes">
                            <textarea v-model="designNotes" style="width: 100%;resize: none;" placeholder="Please add instructions" type="text"></textarea>
                        </div>
                    </div>
                    <div @click="alignLogo(currentDesignIndex)" class="floating-container clickable">
                        <div class="fixed-container">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/align.svg?v=1711657195"/>
                            <p>Align Logo</p>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <p @click="closeModal" class="exit">< BACK</p>
            <div class="title-container mobile">
                <p class="title">{{selectedAddon.title}} <br/> <span class="turnaround">This item typically has a 2-4 week turnaround</span></p>
                <div class="information-container">
                    <div @click="() => {showDesc = !showDesc}" class="information-toggle" :class="showDesc ? 'toggle' : ''">
                        <span>Product Information </span>
                        <div class="arrow" :class="!showDesc ? 'down' : 'up'"></div>
                    </div>
                    <div v-if="showDesc" class="desc-outer-container">
                        <p class="desc" v-html="productDesc"></p>
                    </div>
                    <div v-if="showDesc" class="curtain"></div>
                </div>
            </div>
            <div class="image-outer-container">
                <div  class="main-image-container" id="draggableContainer">
                    <img :src="currentMainImage.src" class="main-image">
                    <div @mouseover="designs[currentDesignIndex].active = true" @mouseleave="deactivateDesign()" v-if="currentDesign && currentDesign.file" id="iContainer" class="image-editor-container" :class="designs[currentDesignIndex].shape ? designs[currentDesignIndex].shape : ''">
                        <DDR @click="activateDesign" id="ddr" v-model="designs[currentDesignIndex].transform" :active="designs[currentDesignIndex].active" :parent="false">
                            <img  class="edit-image" :src="currentDesign.img"/>
                        </DDR>
                    </div>
                </div>
                <div v-if="currentImageList.length > 1" class="image-selectors">
                    <button @click="changeImageIndex(false)" class="image-back"><</button>
                    <button @click="changeImageIndex(true)" class="image-fw">></button>
                </div>
            </div>
        </div>
        <div class="customization-container">
            <div class="title-container desktop">
                <p class="title">{{selectedAddon.title}} <br/> <span class="turnaround">This item typically has a 2-4 week turnaround</span></p>
                <div class="information-container">
                    <div @click="() => {showDesc = !showDesc}" class="information-toggle" :class="showDesc ? 'toggle' : ''">
                        <span>Product Information </span>
                        <div class="arrow" :class="!showDesc ? 'down' : 'up'"></div>
                    </div>
                    <div v-if="showDesc" class="desc-outer-container">
                        <p class="desc" v-html="productDesc"></p>
                    </div>
                    <div v-if="showDesc" class="curtain"></div>
                </div>
            </div>
            <div class="design-container"  v-if="designs.length > 0">
                <p class="title">1. Upload your designs</p>
                <div class="design-input-container" v-for="(design,i) in designs">
                    <input :id="'file'+ design.imgIndex" @change="designUpload($event,i)" class="file-uploader" type="file" />
                    <label class="outer-label" :for="'file'+ design.imgIndex">
                        <div v-if="!design.file" class="inner-label">
                            <span class="main-text"> 
                                Upload {{design.name}} Design <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"/>
                            </span>
                        </div>
                        <div v-else class="inner-label">
                            <span><strong>{{design.name}}:</strong></span>
                            <span class="main-text">{{ design.fileName }}</span>
                        </div>
                    </label>
                    <p v-if="design.file" class="clear-image" @click="clearImage(i)">X</p>
                </div>
                <p class="legend">
                    <img class="i-icon" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"/>
                    <span>Max file size is 10mb. Accepted file types are .png, .jpg, .jpeg and .svg</span>
                </p>
            </div>
            <div v-if="hasVariants" v-for="(option,i) in nonColorOptions" class="option-container">
                <p class="title">{{ i + 2 }}. Choose Available {{ option.name }}</p>
                <div class="variants-button-container">
                    <button class="happybox-button white" :class="optionsSelected[option.position - 1] == variant ? 'selected' : ''" @click="selectVariant(option.position - 1,variant)" v-for="(variant,i) in option.values" :key="variant">
                        {{variant}}
                    </button>
                </div>
                <p v-if="option.name == 'Printing Method'" class="legend">
                    <img class="i-icon" src="https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"/>
                    <span>
                        Your design is applied directly onto the products' surface by pushing ink through
                        a fine mesh screen. This is one of our most popular decoration methods.
                    </span>
                </p>
            </div>
            <div class="form-container">
                <p class="title">{{ nonColorOptions.length + 2 }}. Choose your message</p>
                <div class="blank-card-container">
                    <input :checked="isBlankMessage" v-on:change="changeBlankMessage()" id="blankCard" type="checkbox">
                    <label for="blankCard">Click here if you want your card blank</label>
                </div>
                <div v-if="!isBlankMessage" class="message-container">
                    <label for="message">Your Message:</label>
                    <textarea placeholder="Start typing here..." maxlength="200" v-model="message" v-on:change="changeMessage()" cols="30" rows="3" id="message"></textarea>
                </div>
                <div v-if="!isBlankMessage" class="from-container">
                    <label for="from">From:</label>
                    <input v-on:change="changeFrom()" placeholder="Your Name" maxlength="200" v-model="from" id="from" type="text">
                    <p v-if="isHandwritten" class="purple-span">Characters Remaining {{remainingCharacters}}</p>
                </div>
            </div>
            <div class="mobile-sticky">
                <p class="product-total"><span>Total:</span><span>$ {{ currentPrice }}</span></p>
                <button @click="updateMainAddonProductQuantity" class="happybox-button green border">Add to Box</button>
            </div>
        </div>
        <div class="global-spinner-container" v-if="isLoading">
            <div class="global-spinner"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import colors from '../../assets/colors.js'
import axios from 'axios';
import DDR from 'yoyoo-ddr-vue2'
import 'yoyoo-ddr-vue2/dist/yoyoo-ddr.css'
import * as html2canvas from 'html2canvas';
export default {
    props: {
        selectedAddon: Object,
        isBlankMessage: Boolean
    },
    data() {
        return {
            selectedImage: null,
            metafields: null,
            designs: [],
            showDesc: false,
            optionsSelected: [],
            selectedImageIndex: 0,
            designNotes: "",
            collapsed: false,
            isLoading: false,
            collapsedNotes: true,
            from: '',
            message: '',
        }
    },
    components:{
        DDR
    },
    computed:{
        ...mapGetters([
            'boxQty',
        ]),
        currentImageList(){
            return this.selectedAddon.images.filter(x => x.variant_ids.length == 0 || x.variant_ids.includes(this.selectedVariant.id));
        },
        currentMainImage(){
            return this.currentImageList[this.selectedImageIndex]
        },
        colors(){
            return colors;
        },
        currentSelectedColor(){
           return this.optionsSelected[this.colorOptions.position - 1];
        },
        currentDesignIndex(){
            if(this.designs.length > 0){
                return this.designs.findIndex(x => x.imgIndex == (this.selectedImageIndex + 1));
            }
            
            return null;
        },
        currentDesign(){
            if(this.designs.length > 0){
                return this.designs.find(x => x.imgIndex == (this.selectedImageIndex + 1));
            }

            return null
        },
        productDesc(){
            var desc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;")[0];
            return desc;
        },
        hasVariants(){
            return this.selectedAddon.variants.length > 1 && this.selectedAddon.variants.every(x => !x.sku.toLowerCase().includes("ondemand"));
        },
        nonColorOptions(){
            return this.selectedAddon.options.filter(x => !x.name.includes("Color") && !x.name.includes("Printing Qty"));
        },
        selectedVariant(){
            let productsVariants = this.selectedAddon.variants;
            for (let [i, option] of this.optionsSelected.entries()) {
                productsVariants = productsVariants.filter(x => x["option"+(i+1)] == option);
            }
            if(productsVariants.length == 1){
                return productsVariants[0];
            }

            return this.selectedAddon.variants[0];
        },
        currentVariantProduct(){
            var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
            variantProduct.variants = [this.selectedVariant]

            return variantProduct;
        },
        currentPrice(){
            return (Math.round(parseFloat(this.selectedVariant.price) * 100 * this.currentSelectedQty)) /100;
        },
        hasQtyMin(){
            return this.selectedAddon.tags.includes("QTYMIN");
        },
        qtyMin(){
            if(this.hasQtyMin){
                let tags = this.selectedAddon.tags.split(', ');
                let minTag = tags.find(x => x.includes("QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
        currentSelectedQty(){
            return this.boxQty;
        },
        printVariant(){
            return this.selectedAddon.options.find(x=> x.name.toLowerCase().includes("printing qty"));
        },
        productProperties(){
            let properties = [];
            for(let design of this.designs){
                if(design.file){
                    properties.push({name: `${this.selectedAddon.title}_${design.name}_file` ,value:design.file});
                    properties.push({name: `${this.selectedAddon.title}_${design.name}_custom` ,value:design.custom});
                    properties.push({name: `_showImage` ,value:`${this.selectedAddon.title}_${design.name}_custom`});
                    properties.push({name: `_customUrl` ,value:design.customUrl});
                }
            }
            if(this.designNotes.trim() != ""){
                properties.push({name:`${this.selectedAddon.title}_notes`,value: this.designNotes});
            }
            if(this.hasQtyMin)
                properties.push({name:`qtyMin`,value: this.qtyMin});

            return properties
        },
        remainingCharacters(){
            var currentMessage = this.from + this.message;
            var currentRemainingCharacters = 200 - currentMessage.length;
            
            return currentRemainingCharacters;
        },
        isHandwritten(){
            return this.selectedVariant.title.includes("Handwritten");
        },
    },
    methods:{
        closeModal(){
            this.$emit("closecard");
        },
        selectVariant(position,value){
            this.$set(this.optionsSelected, position, value);
        },
        changeImageIndex(increment){
            if(increment){
                if(this.currentImageList.length == this.selectedImageIndex + 1){
                    this.selectedImageIndex = 0;
                    return
                }
                this.selectedImageIndex++;
            }
            else{
                if(this.selectedImageIndex == 0){
                    this.selectedImageIndex = (this.currentImageList.length - 1);
                    return
                }
                this.selectedImageIndex--;
            }
        },
        clearImage(i){
            this.designs[i].file = null;
            this.designs[i].img = null;
            this.designs[i].fileName = null;
            if(this.printVariant){
                let files = this.designs.filter(x => x.file);
                this.$set(this.optionsSelected, this.printVariant.position - 1,  Math.max(1,files.length));
            }
        },
        alignLogo(i){
            let element = document.getElementById("iContainer");
            if(element){
                let eData = element.getBoundingClientRect();
                let ddr = document.getElementsByClassName("yoyoo-ddr");
                let x = (eData.width / 2) - (this.designs[i].transform.width/2);
                let y = (eData.height / 2) - (this.designs[i].transform.height/2);
                ddr[0].style.left = `${x}px`;
                ddr[0].style.top = `${y}px`;
                this.designs[i].transform.x = x;
                this.designs[i].transform.y = y;
            }
        },
        async designUpload(event,i){
            let file = event.target.files[0] ? event.target.files[0] : null;
            if (file) {
                const reader = new FileReader();
                let that = this;
                reader.readAsDataURL(file);
                const result = await new Promise((resolve, reject) => {
                    reader.onload = function(e) {
                        that.designs[i].file = file;
                        that.designs[i].img = e.target.result;
                        that.designs[i].fileName = file.name;
                        that.selectedImageIndex = (that.designs[i].imgIndex - 1);
                        if(file.type.includes("svg")){
                            let svgString = atob(e.target.result.replace(/data:image\/svg\+xml;base64,/, ''));
                            var re = /#[0-9a-f]{3,6}/gi;
                            let colors = svgString.match(re);
                            that.designs[i].colors = colors;
                            that.designs[i].isVector = true;
                        }
                        resolve(reader.result)
                    }
                })
            }
            event.target.value = '';
            
            if(this.printVariant){
                let files = this.designs.filter(x => x.file);
                this.$set(this.optionsSelected, this.printVariant.position - 1, Math.max(1,files.length));
            }
        },
        activateDesign(){
            this.designs[this.currentDesignIndex].active = true;
        },
        async deactivateDesign(){
            this.designs[this.currentDesignIndex].active = false;
            await this.$nextTick();
            const canvas = await html2canvas(document.querySelector("#draggableContainer"),{allowTaint:false,useCORS:true});
            const blob = this.dataURLtoBlob(canvas.toDataURL('image/png'));
            this.designs[this.currentDesignIndex].custom = new File([blob], "custom.png");
            this.designs[this.currentDesignIndex].customUrl = canvas.toDataURL('image/png');
        },
        updateMainAddonProductQuantity(){
            this.customAlert = '';
            if(this.designs.filter(x => x.file).length == 0){
                this.openDesignAlert();
                return;
            }
            let maxQty = 9999;
            var maxPosible = Math.min(1,maxQty);
            this.updateAddonProduct(this.currentVariantProduct,maxPosible)
        },
        updateAddonProduct(){
            //Update Card Properties
            this.$store.commit('updateCardProperties',{product: null, properties: this.productProperties});
            this.closeModal();
        },
        objectToFormData(currentItem){
            var form_data = new FormData();
            for ( var key in currentItem ) {
                if(key == "properties"){
                    for(var pKey in currentItem[key]) {
                        if(pKey == "gif"){
                            if(this.file && this.fileSelected){
                                form_data.append(`properties[${pKey}]`, this.file);
                                continue;
                            }
                        }
                        if(pKey == "logo"){
                            if(this.logo && this.logoSelected){
                                form_data.append(`properties[${pKey}]`, this.logo);
                                continue;
                            }
                        }
                        form_data.append(`properties[${pKey}]`, currentItem[key][pKey]);
                    }
                }
                else
                    form_data.append(key, currentItem[key]);
            }

            return form_data;
        },
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type:mime});
        },
        openDesignAlert(){
            const alertText = "Please upload your logo in order to proceed";
            Swal.fire({
                title: 'You need to upload a design',
                text: alertText,
                confirmButtonText: 'Back to product',
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-3",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                },
                buttonsStyling: false,
                })
        },
        changeBlankMessage(){
            this.$emit("changeblankmessage");
        },
        changeMessage(){
            this.$emit("changemessage",this.message);
        },
        changeFrom(){
            this.$emit("changefrom",this.from);
        }
    },
    mounted(){
        axios.get(`/products/${this.selectedAddon.handle}?view=metafields`).then((res) => {
            if(res && res.data && res.data.metafields){
                this.metafields = res.data.metafields;
                if(this.metafields.designs){
                    this.designs = this.metafields.designs.map((x) => {
                        let splitInfo = x.split(":");
                        return {
                            name: splitInfo[0]
                            ,imgIndex:Number(splitInfo[1])
                            ,shape:splitInfo[2] ? splitInfo[2].toLowerCase() : 'square'
                            ,file:null
                            ,img:null
                            ,fileName: null
                            ,transform: { x: 0, y: 0, width: 100, height: 100, rotation: 0 }
                            ,isVector: false
                            ,colors: []
                            ,active:false
                            ,custom: null
                            ,customUrl: null
                        }
                    })
                }
            }
        })
        for (let [i, option] of this.selectedAddon.options.entries()) {
            this.optionsSelected[i] = option.values[0]; 
        }
        
    },
}
</script>

<style lang="scss" scoped>

.happybox-button.grey{
    background-color: #E0E0E0;
    border: 1px solid gray;
}

.happybox-button.grey.disabled{
    opacity: 0.6;
}

.happybox-button.grey:hover{
    background-color: lightgray;
}

.brandable-modal-page{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: white;
    z-index: 100;
}

.images-container{
    width: 50%;
    height: 100%;
    padding: 2% 5%;
}

.image-outer-container{
    position: relative;
    width: 100%;
}

.images-container .main-image-container{
    display: flex;
    position: relative;
    width: 100%;
    justify-content: center;
    height: 100%;
}

.image-selectors{
    position: absolute;
    bottom: 0%;
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    justify-content: center;
    height: auto;
    line-height: 1;
}

.image-selectors button{
    width: 2.5vw;
    background-color: white;
    line-height: 1;
    aspect-ratio: 1;
    border-radius: 4px;
    color: #0f0c38;
    font-size: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 0 4px 0px #0000004d;
}

.image-selectors button:hover{
    background-color: #faf7fe;
}

.main-image{
    background-color: #f6f6f6;
    max-width: 100%;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.exit{
    font-size: 1.3vw;
    cursor: pointer;
    font-weight: bold;
    margin-bottom: 5%;
    color: #a01adb;
}

.customization-container{
    width: 50%;
    background-color: #f8f8f8;
    height: 100%;
    border-left: 1px solid #E3E3E3;
    padding: 2% 5%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
}

.image-editor-container{
    position: absolute;
    z-index: 1;
    left: 20%;
    top: 20%;
    width: 60%;
    height: 60%;
}

.image-editor-container.circle{
    border-radius: 50%;
}

.image-editor-container.card{
    position: absolute;
    z-index: 1;
    left: 24%;
    top: 8%;
    width: 51.5%;
    height: 41%;
}

.image-editor-container:hover{
    border: 1px solid black;
}

.image-editor-container.top-left-handle{
    width: 20%;
    top: 0;
    right: 10%;
    left: unset;
    height: 20%;
}

.edit-image{
    max-width: 100%;
    max-height: 100%;
}

.title-container{
    width: 100%;
    border-bottom: 1px solid #E3E3E3;
    align-items: center;
    padding-bottom: 2%;
    margin-bottom: 2%;
    gap: 5px;
    justify-content: space-between;
}

.title-container.mobile{
    display: none;
}

.title-container.desktop{
    display: flex;
    align-items: flex-start;
}

.title-container.desktop .information-toggle{
    margin-top: 0.3rem;
}

.title-container .title{
    font-size: 2.5vw;
    font-family: Karla, sans-serif;
    font-weight: bold;
    line-height: 1.2;
}

.information-container{
    display: flex;
    align-items: center;
    position: relative;
    width: 35%;
}

.title-container .information-toggle{
    border: 1px solid #bdc1ce;
    padding: 4% 10%;
    background-color: #bdf4df;
    font-size: 1vw;
    font-weight: bold;
    border-radius: 8px;
    flex-shrink: 0;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
}

.title-container .information-toggle.toggle{
    border: unset;
    border-radius: unset;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-top: 10%;
    z-index: 2;
}

.desc-outer-container{
    position: absolute;
    border: 5px solid #bdf4df;
    border-radius: 8px;
    padding: 10%;
    background-color: #fff;
    z-index: 2;
    top: 100%;
    right: -10%;
    width: 310%;
    height: auto;
    font-size: 1.15vw;
}

.curtain{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #0003;
    z-index: 1;
}

.color-container, .design-container, .option-container, .sizes-container, .form-container{
    width: 100%;
    border-bottom: 1px solid #E3E3E3;
    padding-bottom: 2%;
    margin-bottom: 2%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.color-container .title, .design-container .title, .option-container .title, .sizes-container .title, .form-container > .title{
    font-weight: bold;
    font-size: 1.3vw;
}

.design-input-container{
    width: 100%;
    display: flex;
    padding: 1%;
    align-items: center;
    gap: 15px;
    margin: 3% 0 2%;
    padding: 0% 5%;
}

.design-input-container .file-uploader{
    display: none;
}

.design-input-container label{
    cursor: pointer;
}

.design-input-container .outer-label{
    background-color: #fff;
    box-shadow: 2px 2px 10px 3px rgba(0,0,0,.04);
    font-size: 1vw;
    font-style: normal;
    padding: 2% 10%;
    border-radius: 40px;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    width: auto;
}

.design-input-container .inner-label{
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 5px;
}

.clear-image{
    font-size: 1.5vw;
    color: gray;
    cursor: pointer;
}

.design-input-container .main-text{
    color: #A01ADB;
    white-space: nowrap;
    font-weight: 600;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 10px;
}

.design-input-container .main-text img{
    width: 12px;
}

.design-container .legend, .option-container .legend{
    display: flex;
    gap: 15px;
    width: 100%;
    align-items: center;
}

.design-container .legend .i-icon, .option-container .legend .i-icon{
    width: 20px;
    height: auto;
}

.design-container .legend span, .option-container .legend span{
    font-size: 0.8vw;
    color: gray;
    line-height: 1.2;
}

.arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    height: 0px;
    transition: all 0.5s;
    cursor: pointer;
}

.arrow.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}

.arrow.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.variant-container{
    width: 100%;
    padding: 0% 5%;
    margin: 3% 0 0%;
}

.colors-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    flex-wrap: wrap;
}

.round-color{
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 100px;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 0px 0.5px #00000099;
}

.round-color.selected:after {
    content: "";
    display: block;
    position: absolute;
    background: transparent;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 50%;
    top: 1px;
    left: 1px;
    border: 2px solid #fff;
}

.variants-button-container{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
}

.variants-button-container button{
    font-size: 1vw;
    padding: 2% 5%;
}

.variants-button-container button.selected{
    background-color: #F3EEFA;
}

.sizes-selection-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
}

.size-selection{
    display: flex;
    align-items: center;
    gap: 10px;
}

.size-selection p{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1;
}


.size-selection input{
    background: unset;
    background-color: white;
    appearance: auto;
    height: unset !important;
    padding: 5px !important;
    border-radius: 4px !important;
    width: 50px;
    min-width: 50px;
    line-height: 1;
    font-size: 12px;
}

.product-total{
    font-size: 1.3vw;
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-weight: bold;
    margin: 1% 0 3%;
}

.total-qty{
    font-size: 1vw;
    color: gray;
    line-height: 1.2;
    width: 100%;
    padding: 0% 5%;
}

.total-qty span{
    color: #502482;
}

.total-qty .red{
    color: red;
}

.mobile-sticky{
    display: flex;
    flex-direction: column;
}

.no-size{
    font-size: 1.15vw;
    display: flex;
}

.color-modal,.box-qty-modal{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #0000002f;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.box-modal-container{
    width: 60%;
    height: auto;
    display: flex;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px #0000002f;
    flex-direction: column;
    align-items: center;
    padding: 3%;
}

.color-modal-container{
    width: 60%;
    height: auto;
    display: flex;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px #0000002f;
    flex-direction: column;
    align-items: center;
    padding: 3%;
}

.color-modal-container .title,.box-modal-container .title{
    font-weight: 700;
    font-size: 3vw;
    line-height: 1;
}

.color-modal-container .subtitle,.box-modal-container .subtitle{
    color: #919191;
    font-size: 1.15vw;
    margin: 2% 0%;
    padding-bottom: 2%;
    border-bottom: 1px solid #919191;
    width: 100%;
    text-align: center;
}

.box-modal-container .subtitle strong{
    font-weight: 700;
}

.color-modal-container button{
    width: 100%;
}

.color-modal-container .red-alert{
    font-size: 1.15vw;
    color: red;
}

.color-modal-container .main-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5%;
}

.color-modal-container .current-pick{
    width: 33%;
}

.color-modal-container .current-pick .title{
    display: flex;
    font-size: 1.5vw;
    font-weight: bold;
    gap: 10px;
    padding: 5% 0%;
    align-items: center;
    justify-content: space-between;
}

.color-modal-container .current-pick img{
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.color-modal-container .color-pick{
    border-left: 1px solid #919191;
    width: 60%;
    padding: 2%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.color-modal-container .color-pick .variant-container{
    margin: unset;
    padding: unset
}

.color-modal-container .color-pick .variant-container .title{
    font-size: 1.5vw;
    font-weight: bold;
    padding: 3% 0%;
}

.color-modal-container .color-pick .final-design{
    color: #919191;
    font-size: 0.9vw;
    font-style: italic;
    margin: 2% 0%;
    padding-bottom: 2%;
    border-bottom: 1px solid #919191;
    width: 100%;
}

.color-modal-container .color-pick .selected-colors{
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.color-modal-container .color-pick .selected-colors span{
    color: #919191;
    font-size: 1.5vw;
    font-weight: bold;
}

.color-modal-container .color-pick .selected-colors .qty{
    color: #0f0c38;
}

.qtys-containers{
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.gifts-qty-container{
    width: 49%;
    display: flex;
    justify-content: space-between;
}

.gifts-qty-container .info-container{
    width: 50%;
}

.gifts-qty-container .main-image{
    width: 40%;
    aspect-ratio: 1;
    object-fit: cover;
}

.gifts-qty-container .item-box{
    width: 40%;
    position: relative;
    display: flex;
}

.gifts-qty-container .item-box .box-image{
    width: 100%;
}
.gifts-qty-container .item-box .addon-images{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    padding: 5%;
    overflow: hidden;
}

.gifts-qty-container .item-box .addon-images img{
    flex: 1;
    max-width: 50%;
    min-width: 25%;
    max-height: 50%;
    min-height: 25%;
}


.gifts-qty-container .info-container p{
    font-size: 1.5vw;
    font-weight: bold;
}

.box-modal-container .buttons-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 2%;
}

.box-modal-container .buttons-container .happybox-button.white{
    font-size: 1vw;
    padding: 1%;
}

.box-modal-container .buttons-container .happybox-button.white:hover{
    background-color: #5CFFC0;
}

.box-qty-input-container{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.box-qty-input-container input{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.3vw;
    width: 40% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
    color: #0F0C38;
}

.box-qty-input-container input::-webkit-inner-spin-button,
.box-qty-input-container input::-webkit-outer-spin-button{
   -webkit-appearance: none;
    margin: 0;
}

.box-qty-input-container button{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2vw;
    padding: 0% 8%;
    line-height: 0;
    margin: 0% 2%;
    color: #0F0C38;
}

.box-qty-input-container button:hover{
    background-color: #faf7fe
}

.floating-editor{
    position: absolute;
    left: 0%;
    width: auto;
    display: flex;
    gap: 20px;
    z-index: 1;
    top: 10%;
}

.floating-editor .arrow-container{
    border: 1px solid #ddddde;
    background-color: #BDF4DF;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    min-width: 40px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    cursor: pointer;
}

.floating-edit-options{
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-basis: 100%;
    width: auto;
    flex-grow: 1;
    flex-shrink: 0;
}

.floating-container{
    border: 1px solid #ddddde;
    background-color: #BDF4DF;
    border-radius: 20px;
}

.fixed-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8vw;
    gap: 15px;
    cursor: pointer;
    padding: 3% 10%;
    width: auto;
}

.fixed-container img{
    height: 15px;
}

.turnaround{
    font-size: 1vw;
    font-family: Karla, sans-serif;
    border-radius: 8px;
    background-color: #f5faff;
    color: #4239bc;
    padding: 0.5rem;
    width: 100%;
    display: block;
    font-weight: 400;
}

.blank-card-container{
    display: flex;
    align-items: center;
    font-size: 1.2vw;
    color: #0f0c38;
    margin: 1% 0%
}

.from-container,.message-container{
    display: flex;
    flex-direction: column;
    width: 100%;
}

.from-container label,.message-container label{
    font-weight: bold;
    color: #0F0C38;
    font-size: 1vw;
}

.from-container input{
    width: 40%;
}

.purple-span{
    font-size: 1vw;
    color: gray;
}

@media screen and (max-width: 767px){
    .brandable-modal-page{
        overflow-y: scroll;
        flex-direction: column;
        top: unset;
        bottom: 0;
        position: absolute;
        height: 100%;
        justify-content: unset;
    }

    .images-container{
        width: 100%;
        height: unset;
    }

    .customization-container{
        border-top: 1px solid #E3E3E3;
        border-left: unset;
        width: 100%;
        height: unset;
        padding: 2% 5% 0%;
        overflow: visible;
    }

    .no-size{
        font-size: 3.5vw;
        align-items: flex-start;
    }

    .title-container.mobile{
        display: flex;
        flex-direction: column;
        align-items: unset;
    }

    .title-container.desktop{
        display: none;
    }

    .title-container .title{
        font-size: 6vw;
    }

    .title-container .information-toggle{
        font-size: 2.5vw;
    }

    .curtain{
        z-index: 1;
    }

    .title-container .information-toggle.toggle{
        z-index: 2;
    }

    .desc-outer-container{
        z-index: 2;
        left: -10%;
        width: 300%;
        right: unset;
        font-size: 3vw;
    }

    .exit{
        font-size: 3.5vw;
        position: sticky;
        background-color: white;
        top: 0;
        z-index: 1;
        border-bottom: 1px solid #E3E3E3;
    }

    .color-container .title, .design-container .title, .option-container .title, .sizes-container .title{
        font-size: 3.5vw;
    }

    .design-input-container .outer-label{
        font-size: 3vw;
        width: 100%;
        padding: 3% 10%;
    }

    .design-container .legend span, .option-container{
        gap: 5px;
    }
    .design-container .legend span, .option-container .legend span{
        font-size: 2.5vw;
    }

    .size-selection p{
        font-size: 3.5vw;
    }

    .variants-button-container button{
        font-size: 3vw;
        padding: 2% 10%;
    }

    .total-qty{
        font-size: 3vw;
    }

    .product-total{
        font-size: 3.5vw;
    }

    .mobile-sticky{
        position: sticky;
        bottom: 0;
        background-color: white;
        padding: 5%;
        margin-left: -6%;
        width: 111%;
        box-shadow: 0 0 2px 0px #0000004d;
    }

    .size-selection{
        border: 1px solid gray;
        border-radius: 30px;
        padding-left: 2%;
        width: 45%;
    }

    .size-selection input{
        border: unset !important;
        border-left: 1px solid gray !important;
        border-radius: 0px 20px 20px 0 !important;
        width: 100%;
    }

    .clear-image{
        font-size: 5vw;
    }

    .color-modal,.box-qty-modal{
        top: 80px;
        height: calc(100% - 80px);
        position: fixed;
    }
    .color-modal-container .main-container{
        flex-direction: column;
    }

    .color-modal-container{
        width: 90%;
    }

    .color-modal-container .title, .box-modal-container .title{
        font-size: 6vw;
    }

    .color-modal-container .subtitle, .box-modal-container .subtitle{
        font-size: 3vw;
    }

    .color-modal-container .current-pick{
        width: 100%;
    }

    .color-modal-container .current-pick .title
    ,.color-modal-container .color-pick .variant-container .title
    ,.color-modal-container .color-pick .selected-colors span
    ,.form-container>.title{
        font-size: 3.5vw;
    }
    .color-modal-container .color-pick{
        width: 100%;
        border-top: 1px solid #919191;
        border-left: unset;
    }

    .color-modal-container .color-pick .final-design{
        font-size: 2vw;
    }

    .box-modal-container{
        width: 90%;
        padding: 5%;
    }

    .qtys-containers{
        flex-direction: column;
        gap: 15px;
        margin: 5% 0;
    }

    .gifts-qty-container{
        width: 100%;
    }

    .gifts-qty-container .info-container p{
        font-size: 6vw;
    }

    .box-qty-input-container input{
        font-size: 3.5vw;
    }

    .box-modal-container .buttons-container{
        gap: 10px;
    }

    .box-modal-container .buttons-container .happybox-button.white{
        font-size: 3vw;
        padding: 2% 0%;
    }

    .box-qty-input-container button{
        font-size: 6vw;
    }

    .floating-editor{
        top: 45%;
    }

    .floating-editor .arrow-container{
        min-height: 80px;
        min-width: 30px;
    }

    .fixed-container{
        font-size: 2.5vw;
    }

    .turnaround
    ,.blank-card-container
    ,.from-container label
    ,.message-container label
    ,.purple-span{
        font-size: 3vw;
    }

    
}


</style>